export default __webpack_public_path__ + "static/typography-header-2560x1728-4a3996141b628b6ff4d85b8c1a1e7a16.jpg";